export const SITE = {
  name: "Rottamazione Auto Roma",
  short: "RAR",
  phoneDisplay: "+39 392 738 8575",
  phoneTel: "+393927388575",
  whatsapp: "https://wa.me/393927388575",
  whatsappMsg:
    "https://wa.me/393927388575?text=Ciao%2C%20vorrei%20un%20preventivo%20per%20la%20rottamazione%20del%20mio%20veicolo%20a%20Roma.",
  phone2Display: "+39 333 338 6960",
  phone2Tel: "+393333386960",
  whatsapp2: "https://wa.me/393333386960",
  whatsapp2Msg:
    "https://wa.me/393333386960?text=Ciao%2C%20vorrei%20un%20preventivo%20per%20la%20rottamazione%20del%20mio%20veicolo%20a%20Roma.",
  email: "romarottazionii@gmail.com",
  area: "Roma e provincia",
  hours: "24 ore su 24 · 7 giorni su 7",
  soccorso: "https://carroassistenzaroma.com",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/servizi", label: "Servizi" },
  { to: "/come-funziona", label: "Come Funziona" },
  { to: "/zone", label: "Zone" },
  { to: "/contatti", label: "Contatti" },
];

export const IMAGES = {
  heroCrushed:
    "https://images.unsplash.com/photo-1770068512613-a459a6a992eb?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  scrapPile:
    "https://images.unsplash.com/photo-1770068512276-cf8c2275f766?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  junkRow:
    "https://images.unsplash.com/photo-1693925380766-830b8062495d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  towTruck:
    "https://static.prod-images.emergentagent.com/jobs/4337f3a5-a81e-4195-aa9d-f77b3603bed6/images/54b3e92bd2357777003d67baf14ff5c2c648aaf702c3b1b3f222cab5243dcffb.jpeg",
  gallery: [
    {
      url: "https://static.prod-images.emergentagent.com/jobs/4337f3a5-a81e-4195-aa9d-f77b3603bed6/images/54b3e92bd2357777003d67baf14ff5c2c648aaf702c3b1b3f222cab5243dcffb.jpeg",
      label: "Carico veicolo",
    },
    {
      url: "https://static.prod-images.emergentagent.com/jobs/4337f3a5-a81e-4195-aa9d-f77b3603bed6/images/22fce371cb2a4d8f00441db2249223d77a7e3cf9cf800a7a84ccc6a11163616f.jpeg",
      label: "Trasporto",
    },
    {
      url: "https://static.prod-images.emergentagent.com/jobs/4337f3a5-a81e-4195-aa9d-f77b3603bed6/images/29a2271d988078a5d7c0afdcfc97031e55f01c04e2dca5ac69dca7103397d912.jpeg",
      label: "Ritiro in sede",
    },
    {
      url: "https://static.prod-images.emergentagent.com/jobs/4337f3a5-a81e-4195-aa9d-f77b3603bed6/images/bb8e0ccdade03dc45e19f49217a736dd70476e0119e88da7865a84d125be651d.jpeg",
      label: "Avvio a demolizione",
    },
  ],
  towCity:
    "https://images.pexels.com/photos/13151224/pexels-photo-13151224.jpeg?auto=compress&cs=tinysrgb&dpr=2&w=1200",
  abandoned:
    "https://images.unsplash.com/photo-1603557275022-48fd88ce4933?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
};
